module.exports = __webpack_public_path__ + "ac90cf724be783405426267c50a28bd0.ttf";